module.exports = __webpack_public_path__ + "static/media/screenshot(34).d3b96303.jpg";